const DEBUG_MODE_STORAGE_PREFIX = "pagebunny:debug-mode:";

export const parseDebugUserEmails = (
  rawValue = process.env.REACT_APP_DEBUG_USER_EMAILS || "",
): Set<string> =>
  new Set(
    rawValue
      .split(",")
      .map((email) => email.trim().toLowerCase())
      .filter(Boolean),
  );

export const isDebugUserEmail = (
  email: string | null | undefined,
  rawValue = process.env.REACT_APP_DEBUG_USER_EMAILS || "",
): boolean => {
  const normalizedEmail = email?.trim().toLowerCase();
  return Boolean(
    normalizedEmail && parseDebugUserEmails(rawValue).has(normalizedEmail),
  );
};

export const getDebugModePreference = (userId: string): boolean => {
  if (typeof window === "undefined" || !userId) return false;

  try {
    return (
      window.localStorage.getItem(`${DEBUG_MODE_STORAGE_PREFIX}${userId}`) ===
      "true"
    );
  } catch {
    return false;
  }
};

export const saveDebugModePreference = (
  userId: string,
  enabled: boolean,
): void => {
  if (typeof window === "undefined" || !userId) return;

  try {
    window.localStorage.setItem(
      `${DEBUG_MODE_STORAGE_PREFIX}${userId}`,
      String(enabled),
    );
  } catch {
    // Keep the in-memory toggle usable when browser storage is unavailable.
  }
};
